import { stockStatusMessages } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"
import { useConfig } from "src/hooks"
import { inventoryAndIntakeMessages } from "../../common/inventoryAndIntake.messages"
import { stockStatusOptionMessages } from "./useStockStatusOptions"

export const useInStockOption = (
	vmsDataSource: "ONE_VMS" | "PVMS" | undefined,
	subsidizedUsageCannotBeTerminated: boolean,
	subsidized?: boolean,
): RadioOption => {
	const { formatMessage } = useIntl()
	const { subsidizedUsage } = useConfig()
	return useMemo(() => {
		return {
			disabledHint: vmsDataSource
				? formatMessage(commonMessages.disabledForVmsVehicle, {
						value: vmsDataSource === "ONE_VMS" ? "OneVMS" : "PVMS",
					})
				: subsidizedUsageCannotBeTerminated
					? formatMessage(inventoryAndIntakeMessages.minimumUsageTimeNotReached)
					: undefined,
			label: formatMessage(stockStatusMessages.IN_STOCK),
			tag:
				subsidized && subsidizedUsage.endUsageDespiteUnsufficientUsageTimePossible
					? formatMessage(stockStatusOptionMessages.takeOutOfService)
					: undefined,
			value: "IN_STOCK",
		}
	}, [
		vmsDataSource,
		formatMessage,
		subsidizedUsageCannotBeTerminated,
		subsidized,
		subsidizedUsage.endUsageDespiteUnsufficientUsageTimePossible,
	])
}
